
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community/featured",
      function () {
        return require("private-next-pages/community/featured.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community/featured"])
      });
    }
  